import { TableBody, TableCell, TableHead, TableRow, Tooltip, CircularProgress, Icon, IconButton } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { downloadFile, validateDownloadHash } from 'store/Orbita/Download/actions';

import type { DispatchProp } from 'react-redux';

const decorate = withStyles((theme) => ({
  content: {
    width: '550px',
    maxWidth: '95%',
    transform: 'translate(-50%, -50%)',
    position: 'fixed',
    top: '50%',
    left: '50%',
    maxHeight: '95vh',
  },
  logo: {
    width: '220px',
    textAlign: 'center',
    marginBottom: 40,
  },
  loading: {
    width: '100%',
    padding: '30px 0',
    lineHeight: 0,
    textAlign: 'center',
  },
  paper: {
    borderRadius: 4,
    overflow: 'auto',
    maxHeight: '70vh',
  },
  footer: {
    fontSize: 13,
    textAlign: 'center',
    padding: '20px 0',
    color: '#596375',
  },
  nameFile: {
    width: '340px',
    maxWidth: '340px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      maxWidth: '100px',
      paddingRight: 12,
    },
  },
  hideMobile: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

interface IProps extends DispatchProp<any> {
  match: any;
  download: any;
  classes: any;
  downloadHashValid: any;
}

function Logo() {
  return (
    <svg id='Camada_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 123.63 32.06' style={{ maxWidth: 140 }}>
      <defs>
        <style>{'.cls-1{fill:#ffbe00;}.cls-2{fill:#17296e;}.cls-3{fill:#212121;}.cls-4{fill:#0d2772;}'}</style>
      </defs>
      <g id='Camada_1-2'>
        <g>
          <g>
            <path className='cls-3' d='M47.95,21.23h-2V7.23h2.2l4.98,11.34,4.96-11.34h2.18v14h-1.98V11.11l-4.44,10.12h-1.46l-4.44-10.12v10.12Z' />
            <path className='cls-3' d='M69.71,11.23h1.96l-5.8,14h-1.86l1.76-4.2-3.96-9.8h2.08l2.9,7.58,2.92-7.58Z' />
            <path className='cls-3' d='M82.57,8.91h-7.36v4.38h5.52v1.68h-5.52v4.58h7.36v1.68h-9.36V7.23h9.36v1.68Z' />
            <path
              className='cls-3'
              d='M92.33,12.93l-.22,.06V6.83h1.9v14.4h-1.72l-.14-1.5c-.33,.45-.78,.84-1.35,1.16-.57,.32-1.26,.48-2.07,.48-.91,0-1.7-.21-2.37-.64-.67-.43-1.2-1.03-1.58-1.8s-.57-1.67-.57-2.7,.19-1.93,.57-2.7c.38-.77,.91-1.37,1.58-1.8,.67-.43,1.46-.64,2.37-.64s1.6,.18,2.21,.53,1.07,.79,1.39,1.31Zm-6.1,3.3c0,1.03,.27,1.85,.8,2.48s1.25,.94,2.14,.94c.55,0,1.04-.13,1.48-.4,.44-.27,.79-.66,1.06-1.17,.27-.51,.4-1.13,.4-1.85s-.13-1.33-.4-1.84c-.27-.51-.62-.9-1.06-1.17-.44-.27-.93-.41-1.48-.41-.88,0-1.59,.31-2.13,.94s-.81,1.45-.81,2.48Z'
            />
            <path
              className='cls-3'
              d='M104.83,21.23h-1.72l-.14-1.18c-.32,.43-.72,.75-1.21,.98-.49,.23-1.03,.34-1.63,.34-.77,0-1.45-.16-2.02-.49s-1.02-.81-1.33-1.44c-.31-.63-.47-1.42-.47-2.37v-5.84h1.9v5.6c0,.92,.19,1.62,.57,2.1,.38,.48,.96,.72,1.73,.72s1.36-.25,1.79-.74c.43-.49,.65-1.23,.65-2.2v-5.48h1.88v10Z'
            />
            <path className='cls-3' d='M114.45,12.77l-5.3,6.78h5.32v1.68h-7.68v-1.54l5.32-6.78h-5.3v-1.68h7.64v1.54Z' />
            <path className='cls-3' d='M123.61,12.77l-5.3,6.78h5.32v1.68h-7.68v-1.54l5.32-6.78h-5.3v-1.68h7.64v1.54Z' />
          </g>
          <g>
            <rect className='cls-2' x='18.21' y='1.94' width='13.05' height='28.19' />
            <circle className='cls-1' cx='18.21' cy='16.03' r='16.03' />
            <path
              className='cls-4'
              d='M7.39,27.42h9.77c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.84-2.82-2.84H4.03s-.02-.05-.03-.08c-.3-.88-.53-1.79-.7-2.74h7.41c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.82-2.82-2.82H3.3c.17-.94,.4-1.87,.71-2.74,0-.03,.02-.05,.03-.08h13.13c1.56,0,2.82-1.26,2.82-2.82s-1.26-2.82-2.82-2.82H7.38c1-1.11,2.15-2.09,3.41-2.9H0V30.13H10.53c-1.15-.78-2.21-1.68-3.14-2.71Z'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

class Downloads extends Component<IProps> {
  componentDidMount() {
    let params = this.props.match.params;

    if (params.hash) {
      (async () => {
        try {
          await this.props.dispatch(downloadFile(params.hash));
        } catch (error) {
          toast.error('Ops, erro na listagem de downloads');
        }
      })();
    }
  }

  async downloadFile(url: string) {
    const hash = url.split('/').pop();
    await this.props.dispatch(validateDownloadHash(hash));

    if (!this.props.downloadHashValid.status) {
      toast.error('Link de download inválido');
      return;
    }

    const link = document.createElement('a');
    link.setAttribute('download', 'true');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const { classes, download } = this.props;

    return (
      <div className={classes.content}>
        <div style={{ textAlign: 'center' }}>
          <Logo />
        </div>

        <Paper className={classes.paper}>
          {download && download.isFetching && (
            <div className={classes.loading}>
              <CircularProgress size={30} style={{ color: '#192542' }} />
            </div>
          )}

          {download && !download.isFetching && (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Arquivo</TableCell>
                  <TableCell className={classes.hideMobile}>Extensão</TableCell>
                  <TableCell> </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {download &&
                  download.length > 0 &&
                  download.map((n: any) => {
                    return (
                      <TableRow key={n.id}>
                        <TableCell component='th' scope='row' className={classes.nameFile}>
                          {n.name}
                        </TableCell>
                        <TableCell className={classes.hideMobile} style={{ textTransform: 'uppercase', width: 80, paddingRight: 0 }}>
                          {n.extension}
                        </TableCell>
                        <TableCell style={{ textAlign: 'right', padding: 0, width: 50, paddingRight: 20 }}>
                          <div onClick={() => this.downloadFile(n.url_download)}>
                            <Tooltip title='Baixar Conteúdo' placement='top'>
                              <IconButton style={{ color: '#192542' }}>
                                <Icon style={{ color: '#192542' }}>cloud_download</Icon>
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                {download && download.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3}>Nenhum arquivo encontrado</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </Paper>
        <div className={classes.footer}>© {new Date().getFullYear()} - Eduzz - Todos os Direitos Reservados</div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    download: state.orbita.Download.downloadFile,
    downloadHashValid: state.orbita.Download.validateDownloadHash,
  };
}

export default connect(mapStateToProps)(decorate(Downloads));
